import React, { useState } from "react";
import luxonUtil from "@date-io/luxon";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import { Alert } from "@material-ui/lab";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { DateTime } from "luxon";
import { createEvent } from "../utils/api";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 166,
    },
    selectAdmin: {
      margin: theme.spacing(1),
    },
    root: {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(2),
      },
    },
  })
);

export function ReserveTime() {
  const classes = useStyles();
  const [fromDate, handleFromDateChange] = useState(DateTime.local());
  const [toDate, handleToDateChange] = useState(DateTime.local());
  const [eventName, handleEventNameChange] = useState("Viikkoryhmä");
  const [arenaNumber, handleArenaNumberChange] = useState(1);
  const [created, setCreated] = useState(false);

  // TODO: Lisää vararauksen syy - eri väri ja label käyttäjille
  return (
    <div className="admin-container">
      <MuiPickersUtilsProvider utils={luxonUtil}>
        <DateTimePicker
          value={fromDate}
          onChange={(date) => date && handleFromDateChange(date)}
          ampm={false}
          className={classes.selectAdmin}
          label="Alkaa"
          minutesStep={15}
        />
        <DateTimePicker
          value={toDate}
          onChange={(date) => date && handleToDateChange(date)}
          ampm={false}
          className={classes.selectAdmin}
          label="Loppuu"
          minutesStep={15}
        />
      </MuiPickersUtilsProvider>
      <br />
      <FormControl required className={classes.formControl}>
        <InputLabel shrink id="name-field-label">
          Varauksen syy
        </InputLabel>
        <Select
          labelId="name-field-label"
          id="name-field"
          value={eventName}
          onChange={(e: React.ChangeEvent<{ value: any }>) =>
            handleEventNameChange(e.target.value)
          }
        >
          <MenuItem value="Viikkoryhmä">Viikkoryhmä</MenuItem>
          <MenuItem value="Koulutus">JAT Koulutus</MenuItem>
          <MenuItem value="Kilpailu">Kilpailu</MenuItem>
          <MenuItem value="Möllikilpailu">Möllikilpailu</MenuItem>
          <MenuItem value="Ulkopuolinen">Ulkopuolinen</MenuItem>
        </Select>
      </FormControl>
      <FormControl required className={classes.formControl}>
        <InputLabel shrink id="arena-select">
          Kenttä
        </InputLabel>
        <Select
          labelId="arena-select"
          id="arena-select"
          value={arenaNumber}
          onChange={(e: React.ChangeEvent<{ value: any }>) =>
            handleArenaNumberChange(e.target.value)
          }
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={2}>2</MenuItem>
          <MenuItem value={3}>3</MenuItem>
        </Select>
      </FormControl>
      <br />
      <Button
        variant="contained"
        color="secondary"
        className={classes.selectAdmin}
        onClick={() => {
          createEvent(fromDate, toDate, eventName, arenaNumber).then(() => {
            setCreated(true);
            setTimeout(() => {
              setCreated(false);
            }, 4000);
          });
        }}
      >
        Luo varaus
      </Button>

      {created && (
        <div className={classes.root}>
          <Alert severity="success">
            Varaus luotu: {eventName}, Kenttä {arenaNumber}, {fromDate.day}.
            {fromDate.month}.{fromDate.year} klo {fromDate.hour}:
            {fromDate.minute}
          </Alert>
        </div>
      )}
    </div>
  );
}
export default ReserveTime;
